export default () => ({
    loading:false,
    invoices:[],
    total:0,
})
